module.exports = __webpack_public_path__ + "static/media/download.71c04be7.svg";